import React, { useState, useEffect } from "react";
import Select from "react-select";
import TopHeading from "../Heading/TopHeading";
import UserChildrenBox from "../Children/UserChildrenBox";
import { AddChildModal } from "./AddChildModal/AddChildModal";
import { Form, Row, Col } from "react-bootstrap";
import axios from "../../axios";
import { toast } from "react-toastify";
import { Loader, NoContent, Pagination, SearchBar } from "../UI";
import PendingChildrenItem from "./PendingChildrenItem";

export default function UserChildrenContent() {
  const authToken = localStorage.getItem("access_token");
  const isAdmin = localStorage.getItem("isAdmin");
  const apiURL = isAdmin == 0 ? "/user-children" : "/children";
  const [userChildren, setUserChildren] = useState([]);
  const [currentChildren, setCurrentChildren] = useState([]);
  const itemsPerPage = 12;
  const [isLoading, setIsLoading] = useState(true);
  const selectStyles = { borderColor: "#0755991e" };
  const statusOpts = [
    { value: "pending", label: "Pending" },
    { value: "registered", label: "Registered" },
  ];
  const [childSearch, setChildSearch] = useState("");
  const [parentSearch, setParentSearch] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);

  const filterMethods = [
    (item) =>
      (item.firstName + " " + item.lastName)
        .toLowerCase()
        .indexOf(childSearch.toLowerCase()) != -1,
    (item) =>
      item.user
        ? (item.user.firstName + " " + item.user.lastName)
            .toLowerCase()
            .indexOf(parentSearch.toLowerCase()) != -1
        : true,
    (item) =>
      selectedStatus !== null ? item.status === selectedStatus.value : true,
  ];

  const filteredChildren = userChildren.filter((item) => {
    for (let i = 0; i < filterMethods.length; i++) {
      if (!filterMethods[i](item)) {
        return false;
      }
    }
    return true;
  });

  const fetchChildren = () => {
    axios
      .get(apiURL, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        if (response.data) {
          setUserChildren(response.data);
          console.log(response.data);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        toast.error("Couldn't load children");
        setIsLoading(false);
      });
  };

  const addNewChild = (values) => {
    axios
      .post("/children", values, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.data.message);
          fetchChildren();
        } else {
          toast.warn("No response from server");
        }
      })
      .catch((error) => {
        toast.error("Something went wrong");
      });
  };

  useEffect(() => {
    fetchChildren();
  }, []);

  return (
    <section className="user-children-content">
      <div className="container">
        <div className="row g-0">
          <div className="col-md-12">
            <TopHeading title="Children" />
            <div className="my-children light-bg corner-radius p-4 mb-3 main-content custom-scrollbar">
              {isAdmin == 0 && (
                <div className="d-flex justify-content-between mb-4">
                  <h5 className="mb-0">My Children</h5>
                  <AddChildModal
                    addNewChild={addNewChild}
                    setIsLoading={setIsLoading}
                  />
                </div>
              )}
              {isAdmin != 0 && (
                <div className="">
                  <Form>
                    <Row>
                      <Col md="4">
                        <Form.Group className="mb-3">
                          <Form.Label>Status</Form.Label>
                          <Select
                            styles={{
                              control: (styles) => ({
                                ...styles,
                                ...selectStyles,
                              }),
                            }}
                            options={statusOpts}
                            isSearchable={false}
                            isClearable={true}
                            onChange={(option) => setSelectedStatus(option)}
                          />
                        </Form.Group>
                      </Col>
                      <Col md="4">
                        <Form.Group className="mb-3">
                          <Form.Label>Child Name</Form.Label>
                          <SearchBar
                            placeholder="Search Child Name"
                            value={childSearch}
                            onChange={(e) => setChildSearch(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col md="4">
                        <Form.Group className="mb-3">
                          <Form.Label>Parent Name</Form.Label>
                          <SearchBar
                            placeholder="Search Parent Name"
                            value={parentSearch}
                            onChange={(e) => setParentSearch(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Form>
                </div>
              )}
              {isLoading ? (
                <Loader />
              ) : filteredChildren.length ? (
                isAdmin == 0 ? (
                  <div className="row g-0">
                    {filteredChildren.length > itemsPerPage
                      ? currentChildren.map((item) => {
                          return (
                            <UserChildrenBox data={item} key={item.childId} />
                          );
                        })
                      : filteredChildren.map((item) => {
                          return (
                            <UserChildrenBox data={item} key={item.childId} />
                          );
                        })}
                  </div>
                ) : (
                  <div className="list-table table-responsive">
                    <table className="table align-middle mb-0 table-borderless">
                      <thead className="primary-button fw-bold">
                        <tr>
                          <td className="ps-3 py-2">Sr No.</td>
                          <td className="py-2">Child Name</td>
                          <td className="py-2">Parent Name</td>
                          <td className="py-2">Date Applied</td>
                          <td className="text-end pe-3 py-2">Action</td>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredChildren.length > itemsPerPage
                          ? currentChildren.map((item, index) => {
                              return (
                                <PendingChildrenItem
                                  data={item}
                                  key={item.childId}
                                  srNo={index + 1}
                                />
                              );
                            })
                          : filteredChildren.map((item, index) => {
                              return (
                                <PendingChildrenItem
                                  data={item}
                                  key={item.childId}
                                  srNo={index + 1}
                                />
                              );
                            })}
                      </tbody>
                    </table>
                    {filteredChildren.length > itemsPerPage && (
                      <div className="d-flex justify-content-end">
                        <Pagination
                          data={filteredChildren}
                          setCurrentItems={setCurrentChildren}
                          itemsPerPage={itemsPerPage}
                        />
                      </div>
                    )}
                  </div>
                )
              ) : (
                <NoContent />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
